export const fileLimitsMixin = {
  props: {
    // Akceptowane typy plików
    accept: { type: String },
    // Maksymalny rozmiar plików (w bajtach?)
    maxSize: { type: Number }
  }
};
